// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2hdXO","rightAdornment":"Header_rightAdornment__3n-61"};